var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-content",class:_vm.styleType},[_c('div',{staticClass:"box"},[_c('span',{ref:"text",staticClass:"text1",style:({left: `${_vm.scrollPosition}px`})},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"text2",style:({left: `${_vm.scrollPosition2}px`})},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }